module.exports = __webpack_public_path__ + "img/logo-app.32fce91f.png";